import { ConflictBadge } from "@/shared/components/conflict-badge";
import { SimulacaoMarcaTag } from "@/shared/components/simulacao-marca";
import type { GanttFornecedorNomeViewModel } from "./types-gantt-fornecedor-nome";
import styles from "../../carga-fornecedor-gantt.module.scss";

export function GanttFornecedorNomeView({
  row,
  rotuloConflito,
  marca,
  onConflictHover,
  onConflictLeave,
}: GanttFornecedorNomeViewModel) {
  return (
    <span className={styles.nameLine}>
      <span className={styles.name} title={row.title}>
        {row.title}
      </span>
      {rotuloConflito ? (
        <ConflictBadge
          label={rotuloConflito}
          onMouseEnter={(event) => onConflictHover?.(row.conflictInfos ?? [], event)}
          onMouseLeave={onConflictLeave}
        />
      ) : null}
      {marca ? <SimulacaoMarcaTag marca={marca} /> : null}
    </span>
  );
}
